// import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { ChevronDownIcon } from 'lucide-react';
import { useOnViewportChange } from '@xyflow/react';
import React, { useEffect } from 'react';
import { cn } from '../../lib/utils';
import { useParams } from 'next/navigation';
import { useAtomValue } from 'jotai';
import { isStreamingMapAtom } from '../../jotaiStore';

export const ReactFlowInstructions = () => {
  const { contentSlug } = useParams();
  const isStreaming = useAtomValue(isStreamingMapAtom);

  const [showInstructions, setShowInstructions] = React.useState(false);
  const [hasInteracted, setHasInteracted] = React.useState(false);

  useEffect(() => {
    if (!contentSlug && !hasInteracted && !isStreaming) {
      const timer = setTimeout(() => {
        setShowInstructions(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [contentSlug, hasInteracted, isStreaming]);

  useOnViewportChange({
    onStart: () => {
      setHasInteracted(true);
      setShowInstructions(false);
      // if (showInstructions) mixpanelClient.track('map_interaction');
    },
  });

  return (
    <div className="flex justify-center absolute top-[15%] right-[7%] transform z-50">
      <div
        className={cn(
          'flex flex-col items-center transition-all duration-500',
          showInstructions && 'opacity-100',
          !showInstructions && 'opacity-0 pointer-events-none'
        )}
      >
        <div className="flex flex-col items-center">
          <ChevronDownIcon
            className={cn(
              'h-10 w-10 text-colors-orange/95 stroke-[3px]',
              showInstructions && 'animate-chevronPulse'
            )}
          />
          <ChevronDownIcon
            className={cn(
              'h-10 w-10 text-colors-orange/95 -mt-5 stroke-[3px]',
              showInstructions && 'animate-chevronPulseDelayed'
            )}
          />
        </div>
      </div>
    </div>
  );
};
